module.exports = __webpack_public_path__ + "7ab6accc71ca6d5fa9661ac2319bb08a.png";